import React from 'react';
import BackButton from './BackButton';

/**
 * Page header: back button + title
 * Mobile: full-bleed white bar, centered title (Figma nav-bar pattern)
 * Desktop (sm+): back + title left-aligned, optional right action
 */
export default function PageHeader({ title, rightAction }) {
  return (
    <div className="-mx-4 sm:mx-0 -mt-5 sm:mt-0 bg-white sm:bg-transparent px-2.5 sm:px-0 py-5 sm:py-0">
      <div className="flex items-center">
        <BackButton />
        <span className="flex-1 text-center sm:text-left sm:flex-none sm:ml-3 text-sm sm:text-lg font-bold text-mono-900">
          {title}
        </span>
        <div className="w-6 h-6 sm:hidden" />
        {rightAction && <div className="hidden sm:flex sm:ml-auto">{rightAction}</div>}
      </div>
    </div>
  );
}
